import { Button, Grid, Typography, useMediaQuery } from "@mui/material";

const Header = ({}) => {
  const isMobile = useMediaQuery("(max-width:900px)");
  const handlePhoneClick = () => {
    window.location.href = `tel:07700145577`;
  };
  return (
    <Grid
      display={"flex"}
      px={isMobile ? 2.5 : 5}
      py={isMobile ? 1.9 : 2.5}
      // pb={isMobile ? 2 : 3.4}
      bgcolor={"white"}
      sx={{ position: "fixed", zIndex: 10 }}
      width={"100%"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <Grid
        sx={{ cursor: "pointer" }}
        onClick={() => window.open("https://smuve.uk", "_self")}
        width={isMobile ? "192.49px" : "222px"}
        height={isMobile ? "110.74px" : "127.71px"}
      >
        <img src={require("../assets/logo.png")} width={"100%"} />
      </Grid>
      <Grid
        // gap={2}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        {!isMobile && (
          <Button
            onClick={handlePhoneClick}
            variant="contained"
            sx={{
              border: 0,
              boxShadow: "none",
              // mr: 2,
              borderRadius: "5px",
              width: "206.44px !important",
              height: "60px !important",
              px: "40px",
              py: "12px",
              fontSize: "20px",
              backgroundColor: "#e5e5ea !important",
              color: "#1B66B2 !important",
              "&:hover": {
                backgroundColor: "#1b66b2 !important",
                color: "#FFFFFF !important",
              },
            }}
          >
            <Typography fontWeight={"bold"} fontSize={"22px"}>
              Call now
            </Typography>
          </Button>
        )}

        <Grid
          onClick={handlePhoneClick}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          sx={{
            ml: 3.4,
            mr: isMobile ? 0.65 : 1.2,
            cursor: "pointer",
            width: isMobile ? 38 : 48,
            height: isMobile ? 38 : 48,
            borderRadius: "50%",
            backgroundColor: "#3576b9",
          }}
        >
          <img
            width={"100%"}
            src="https://smuve.uk/wp-content/themes/mbn-child/landers/jc-assets/img/icn-call.svg"
          />
          {/* <CallIcon
            sx={{ color: "white", fontSize: isMobile ? "22px" : "30px" }}
          /> */}
        </Grid>
        {!isMobile && (
          <Typography
            sx={{ cursor: "pointer" }}
            onClick={handlePhoneClick}
            fontSize={"24px"}
            color={"primary"}
            fontWeight={700}
          >
            0770 014 5577
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default Header;
